export function getElapsedTime(pastTime) {
  const currentTime = new Date();
  const pastDate = new Date(pastTime);
  const elapsedMilliseconds = currentTime - pastDate;

  const seconds = Math.floor(elapsedMilliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  const readableFormat = [];

  if (days > 0) {
    readableFormat.push(`${days} day${days > 1 ? "s" : ""}`);
  }
  if (hours % 24 > 0) {
    readableFormat.push(`${hours % 24} hour${hours % 24 > 1 ? "s" : ""}`);
  }
  if (minutes % 60 > 0) {
    readableFormat.push(`${minutes % 60} min${minutes % 60 > 1 ? "s" : ""}`);
  }

  return readableFormat.join(" ");
}

export function getElapsedTimeTwo(pastTime) {
  const currentTime = new Date();
  const pastDate = new Date(pastTime);
  const elapsedMilliseconds = currentTime - pastDate;

  const seconds = Math.floor(elapsedMilliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""}`;
  } else if (hours > 0) {
    return `${hours} hour${hours > 1 ? "s" : ""}`;
  } else {
    return `${minutes} min${minutes > 1 ? "s" : ""}`;
  }
}